import React from 'react';
import { motion } from 'framer-motion';
import { DumbbellIcon, TimerIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const badges = [{
  icon: DumbbellIcon,
  label: 'Fuerza'
}, {
  icon: TimerIcon,
  label: 'Running'
}, {
  icon: ShieldCheckIcon,
  label: 'Sin lesiones'
}];
export function Hero() {
  return <header className="relative overflow-hidden border-b border-ink-800 bg-ink-950" data-id="element-33" data-mp="4njpeactjvaz">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-14 lg:grid-cols-[1.15fr_1fr] lg:gap-14 lg:py-20" data-id="element-34" data-mp="128yxm77pblw0">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-35" data-mp="x8b6lljh351s">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-flame-500/40 bg-flame-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-flame-400" data-id="element-36" data-mp="nbosdflnjc8q">
            Entrenamiento híbrido
          </p>

          <h1 className="font-display text-5xl font-extrabold uppercase leading-[0.92] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-37" data-mp="3j8sd1u7lx7mo">
            Deja de elegir:
            <span className="mt-2 block text-flame-500" data-id="element-38" data-mp="3o5j4tesrxrnx">
              construí un cuerpo que se vea fuerte
            </span>
            <span className="block" data-id="element-39" data-mp="3e9fuvmrokoqf">y rinda como el de un atleta de élite.</span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-zinc-400" data-id="element-40" data-mp="30i1abbi4kfh9">
            El sistema de entrenamiento inteligente para ganar músculo y correr tus
            mejores 10K <strong className="font-semibold text-white" data-id="element-41" data-mp="35aucpsq4fbq6">simultáneamente</strong>,
            sin lesiones ni sobreentrenamiento.
          </p>

          <ul className="mt-7 flex flex-wrap gap-2" data-id="element-42" data-mp="2vievwyqk8t6v">
            {badges.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 rounded-md border border-ink-700 bg-ink-900 px-3 py-2 text-sm font-medium text-zinc-300" data-id="element-43" data-mp="2hix224yeqpqn">
                <Icon className="h-4 w-4 text-flame-500" aria-hidden="true" data-id="element-44" data-mp="s335tfryasyl" />
                {label}
              </li>)}
          </ul>

          <div className="mt-9 max-w-xl" data-id="element-45" data-mp="n9i4bdr5fgun">
            <CTAButton data-id="element-46" data-mp="ibgnkzh73tmc" />
            <p className="mt-3 text-center text-sm text-zinc-500" data-id="element-47" data-mp="icrpetr2yrat">
              Pago único de $17.990 ARS · Acceso inmediato · Garantía de 7 días
            </p>
          </div>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-48" data-mp="1b0drtyoknpw3">
          <div className="stripes absolute -inset-4 rounded-2xl" aria-hidden="true" data-id="element-49" data-mp="114kjkrhvyik4" />
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/0d1345ce-4b04-405a-800a-1f2621272fc8.jpg" alt="Atleta híbrido corriendo a máxima velocidad en una pista de noche" className="relative w-full rounded-xl border border-ink-700 object-cover shadow-2xl" loading="eager" data-id="element-50" data-mp="x37cyf6yybc5" />
          <div className="absolute bottom-4 left-4 right-4 rounded-lg border border-ink-700 bg-ink-950/90 p-4 backdrop-blur" data-id="element-51" data-mp="21a4tjve00i5z">
            <p className="font-display text-2xl font-extrabold uppercase italic text-white" data-id="element-52" data-mp="268g2m3wgyon5">
              12 semanas
            </p>
            <p className="text-sm text-zinc-400" data-id="element-53" data-mp="2b2k6geafugk0">
              Programación día por día: fuerza + carrera, sin interferencia.
            </p>
          </div>
        </motion.div>
      </div>
    </header>;
}